import { clearLocalGames } from './localGames.js';
import { forgetStarted } from './lastStarted.js';
import { forgetPlayerSettings } from './settingsStore.js';

/**
 * Clears what this device keeps for one player whose data was deleted (D05):
 * their saved games, which are also their pending uploads, their resume
 * marker and the device settings that name them. Other players on the device
 * keep theirs, and nothing device-wide is wiped.
 *
 * Called only once the server has taken the deletion, so a request that fails
 * leaves every game where it was.
 */
export async function forgetPlayerData(playerId: string): Promise<void> {
  forgetStarted(playerId);
  forgetPlayerSettings(playerId);
  await clearLocalGames(playerId);
}
